import * as Config from '@/Config';
import * as Manager from '@/Manager';
import ChalkySticks from '@chalkysticks/vue2-components';
import RegisterComponents from '@/Utility/RegisterComponents';
import Store from '@/Store';
import Vue from 'vue';
import { assetRef } from '@/Manager/Asset';

/**
 * Register assets
 */
Manager.Asset.createIndex();

/**
 * Register Alert Manager ($alert prototype + dialog event bus)
 */
Manager.Alert.install(Vue);

/**
 * Disable Vue settings
 */
Vue.config.devtools = !Config.Environment.IS_PRODUCTION;
Vue.config.productionTip = false;
Vue.config.silent = true;

/**
 * Global event bus
 */
Vue.prototype.$bus = new Vue();

/**
 * Prototypes
 */
Vue.prototype.$asset = assetRef;

/**
 * Disable console logs if Config.Environment.IS_PRODUCTION
 */
if (Config.Environment.IS_PRODUCTION) {
	console.error = () => {
		/* Do nothing */
	};
	console.info = () => {
		/* Do nothing */
	};
	console.log = () => {
		/* Do nothing */
	};
	console.warn = () => {
		/* Do nothing */
	};
}

/**
 * Register components
 */
Vue.use(RegisterComponents, Config);

/**
 * Register ChalkySticks components
 */
Vue.use(ChalkySticks, {
	google: {
		maps: {
			api_key: Config.App?.GOOGLE_MAP_API,
		},
	},
	provide: {
		store: Store,
	},
	sdk: {
		api_url: 'https://api.chalkysticks.com',
	},
});
